var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-10"},[_c('v-alert',{attrs:{"color":"error","type":"error"}},[_c('h3',[_vm._v("غير مصرح لك بمشاهدة هذه الصفحة")]),_c('b',[_vm._v("لا تملك الصلاحيات الكافية للوصول الى هذه الصفحة")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }